<template>
  <div class="signUp">
    <div class="center">
      <p class="tit">Sign Up</p>
      <div class="info">
        <div>
          <span>Name</span>
          <input type="text">
        </div>
        <div>
          <span>Company Name</span>
          <input type="text">
        </div>
        <div>
          <span>Email</span>
          <input type="text">
        </div>
        <div>
          <span>What verticals do you offer?</span>
          <input type="text">
        </div>
        <div>
          <span>Message</span>
          <textarea name="" id="" cols="30" rows="8"></textarea>
        </div>
      </div>
      <div class="submit transformBtn">SUBMIT</div>
    </div>
  </div>
</template>

<script>
  export default {
    name:'',
    data(){
      return {

      };
    },
    created(){
      // 传参控制显示顶部和底部
      this.$emit('controlShow', false);
    },
    computed:{
      MenuKey(){
        return this.$store.state.menuKey;
      }
    },
    methods:{},
  }
</script>
<style lang='less' scoped>
.signUp{
  width: 100%;
  box-sizing: border-box;
  padding: 150px 0 350px;
  background: url('../../static/signUp/background.png') no-repeat;
  background-size: 100% 100%;
  .center{
    width: 1200px;
    height: 770px;
    background-color: #fff;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 65px 150px;
    .tit{
      text-align: center;
      color: #101010;
      font-size: 38px;
    }
    .info{
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      flex-wrap: wrap;
      div{
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0 20px 20px;
        span{
          margin-bottom: 5px;
        }
        input{
          height: 36px;
        }
      }
      div:last-child{
        width: 100%;
        margin: 0 30px;
      }
    }
    .submit{
      width: 93%;
      height: 60px;
      margin: 55px auto 0;
      border-radius: 8px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      background: linear-gradient(to left, #E11F27 0%, #AE2025 100%,);
    }
  }
}
@media screen and (max-width:500px) {
  .signUp{
    width: 100%;
    box-sizing: border-box;
    padding: 50px 0 50px;
    background: url('../../static/signUp/background.png') no-repeat;
    background-size: 100% 100%;
    .center{
      width: 90%;
      height: auto;
      background-color: #fff;
      margin: 0 auto;
      box-sizing: border-box;
      padding: 25px 0px;
      margin-top: 30px;
      .tit{
        text-align: center;
        color: #101010;
        font-size: 16px;
      }
      .info{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        flex-wrap: wrap;
        div{
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          margin: 0 20px 20px;
          span{
            margin-bottom: 5px;
            font-size: 12px;
          }
          input{
            height: 26px;
          }
        }
        div:last-child{
          width: 100%;
          margin: 0 20px;
        }
      }
      .submit{
        width: 90%;
        height: 40px;
        margin: 35px auto 0;
        border-radius: 8px;
      }
    }
  }
}
</style>